// Core
import { takeEvery } from 'redux-saga/effects';

// Instruments
import { hotActions as actions } from '../actions';
import {
    getBlockWorker, getTourWorker, getToursCountriesWorker,
    getCountryRecommendedToursWorker
} from './workers';

export const hotWatchers = Object.freeze({
    * getBlockWatcher () {
        yield takeEvery(actions.getBlock, getBlockWorker);
    },
    * getTourWatcher () {
        yield takeEvery(actions.getTour, getTourWorker);
    },
    * getToursCountriesWatcher () {
        yield takeEvery(actions.getToursCountries, getToursCountriesWorker);
    },
    * getCountryRecommendedToursWatcher () {
        yield takeEvery(actions.getCountryRecommendedTours, getCountryRecommendedToursWorker);
    },
});
